export const toArray = (data?: string | string[]): string[] =>
  !data ? [] : Array.isArray(data) ? data : [data];
